import { Component } from '@angular/core';

@Component({
    selector: 'app-alarme-compromisso',
    templateUrl: './alarme-compromisso.component.html',
    styleUrl: './alarme-compromisso.component.css',
    standalone: false
})
export class AlarmeCompromissoComponent {

}
